// A MAT's schools arrive in two shapes: GetMatGroupDetails may return them top-level, while
// GetById only exposes them nested under the first group director's MatGroup. A collection
// that is absent from both places means "unknown", which is not the same as "none".
const schoolsOf = (mat) => {
  if (Array.isArray(mat?.Schools)) return mat.Schools;
  const nested = mat?.GroupDirectors?.[0]?.MatGroup?.Schools;
  return Array.isArray(nested) ? nested : null;
};

export const activeSchoolsOf = (mat) => (schoolsOf(mat) || []).filter((school) => !school.IsArchived);

export const activeSchoolCountOf = (mat) => {
  const schools = schoolsOf(mat);
  return schools ? schools.filter((school) => !school.IsArchived).length : null;
};
